import { EWordType } from 'shared/models';

export const SEARCH_KEYWORD_NONE = 'none' as const;

export const SearchKeywordSource = {
  [EWordType.SarWord]: 'sar',
  [EWordType.GuessWord]: 'recom_search',
  [EWordType.RSWord]: 'related_search',
  [EWordType.BreadcrumbsWord]: 'breadcrumbs_word',
  [SEARCH_KEYWORD_NONE]: '',
};
